import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowsHide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowsHide"><Path d="M15.5303 16.2197L14.4697 17.2803L12.75 15.5605V21H11.25V15.5605L9.53027 17.2803L8.46973 16.2197L12 12.6895L15.5303 16.2197Z" fill="currentColor"/><Path d="M8 5.5H3.5V18.5H8V20H2V4H8V5.5Z" fill="currentColor"/><Path d="M22 20H16V18.5H20.5V5.5H16V4H22V20Z" fill="currentColor"/><Path d="M12.75 8.43945L14.4697 6.71973L15.5303 7.78027L12 11.3105L8.46973 7.78027L9.53027 6.71973L11.25 8.43945V3H12.75V8.43945Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowsHide;
